import { createTabSlice } from '../helpers';

const tabs = [
  {
    label: 'To Do',
    icon: 'CreateIcon',
    component: 'LabellerDashboard/Todo',
  },
  {
    label: 'Pending',
    icon: 'ScheduleIcon',
    component: 'LabellerDashboard/Pending',
  },
  {
    label: 'Finished',
    icon: 'DoneIcon',
    component: 'LabellerDashboard/Finished',
  },
];

export const tabSlice = createTabSlice({ name: 'labellerDashboard/tabs', tabs });
